import Timer from 'app/components/Timer'
import { setSeconds } from 'date-fns'

export default ({ size = 'big', secondsArray = [60, 90, 120, 150, 180] }) => {
  const [seconds, setSeconds] = useState(0)
  const [enabled, setEnabled] = useState(false)
  const [soundEnabled, setSoundEnabled] = useState(true)

  const sound = useMemo(() => {
    return new Audio(`${API_URL}/audio/bell_x3.mp3`)
  })

  const onClickSetSeconds = useCallback((e) => {
    const newSeconds = parseInt(e.target.dataset.seconds)
    if (newSeconds > 0) setSeconds(newSeconds)

    setEnabled(true)
  })

  const toggleSound = useCallback(() => {
    setSoundEnabled((prevSoundEnabled) => {
      setSoundEnabled(!prevSoundEnabled)
    })
  })

  const onTimeout = useCallback(() => {
    if (soundEnabled) sound.play()
    setEnabled(false)
    setSeconds(0)
  })

  return (
    <div className="fcol">
      <Timer
        size={size}
        seconds={seconds}
        enabled={enabled}
        onTimeout={onTimeout}
      />
      <div className="frow btn-group">
        {secondsArray.map((secondsParam) => {
          return (
            <div
              key={secondsParam}
              data-seconds={secondsParam}
              onClick={onClickSetSeconds}
              className="flex-1 btn btn-lg btn-transparent-gray"
            >
              {secondsParam}
            </div>
          )
        })}
        <div className="btn btn-lg btn-transparent-gray" onClick={toggleSound}>
          <i
            className={clsx('ph', {
              'ph-speaker-high': soundEnabled,
              'ph-speaker-simple-slash': !soundEnabled
            })}
          />
        </div>
      </div>
    </div>
  )
}
